(function(){
  'use strict';
  var routes = window.routes || {cartAdd:'/cart/add.js',cartChange:'/cart/change.js',cart:'/cart'};
  var body = document.body;
  var DRAWER_ID = 'shopify-section-cosea-cart-drawer';

  /* ---------- menu mobile ---------- */
  var burger = document.querySelector('.burger');
  if (burger) burger.addEventListener('click', function(){
    var open = body.classList.toggle('menu-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var mm = document.querySelector('.mmenu'); if (mm) mm.setAttribute('aria-hidden', open ? 'false' : 'true');
  });

  /* ---------- reveal au scroll ---------- */
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function bindReveal(root){
    var els = (root || document).querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          var sibs = Array.prototype.slice.call(en.target.parentElement.querySelectorAll(':scope > .rv'));
          var i = Math.max(0, sibs.indexOf(en.target));
          en.target.style.transitionDelay = (i*0.08)+'s';
          en.target.classList.add('in'); io.unobserve(en.target);
        }
      });
    }, {threshold:.12, rootMargin:'0px 0px -7% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  bindReveal(document);

  /* ---------- panier : ouverture / fermeture ---------- */
  function openCart(){ body.classList.add('cart-open'); }
  function closeCart(){ body.classList.remove('cart-open'); }
  var tmr; function toast(msg){
    var t = document.getElementById('toast'); if(!t) return;
    document.getElementById('toastMsg').textContent = msg;
    t.classList.add('show'); clearTimeout(tmr); tmr = setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }
  function setBadge(n){
    var b = document.getElementById('cartCount'), nav = document.getElementById('navCart');
    if (b) b.textContent = n;
    if (nav) nav.classList.toggle('has', n > 0);
  }

  /* ---------- synchro tiroir (API rendu de section + /cart.js) ---------- */
  function syncCart(){
    var url = window.location.pathname + '?sections=cosea-cart-drawer';
    return Promise.all([
      fetch(routes.cart + '.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}),
      fetch(url, {headers:{'Accept':'application/json'}}).then(function(r){return r.json();})
    ]).then(function(res){
      var cart = res[0], sections = res[1];
      var html = sections['cosea-cart-drawer'];
      var el = document.getElementById(DRAWER_ID);
      if (el && html != null){ el.outerHTML = html; }
      setBadge(cart.item_count);
      return cart;
    });
  }

  function addToCart(formOrObj, opts){
    opts = opts || {};
    var btn = opts.btn || document.getElementById('pdpAdd');
    if (btn){ btn.disabled = true; btn.classList.add('is-loading'); }
    var fetchOpts = { method:'POST', headers:{'Accept':'application/json'} };
    if (formOrObj instanceof FormData){ fetchOpts.body = formOrObj; }
    else { fetchOpts.headers['Content-Type'] = 'application/json'; fetchOpts.body = JSON.stringify(formOrObj); }
    return fetch(routes.cartAdd, fetchOpts).then(function(r){ return r.json(); }).then(function(data){
      if (data.status){ toast('Un souci est survenu.'); return null; }
      return syncCart().then(function(){
        if (opts.checkout){ window.location.href = '/checkout'; return; }
        toast(opts.msg || 'Ajouté au panier'); openCart();
      });
    }).catch(function(){ toast('Réseau indisponible, réessaie.'); })
      .finally(function(){ if (btn){ btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  function changeLine(key, qty){
    return fetch(routes.cartChange, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); }).then(function(){ return syncCart(); });
  }

  /* ---------- délégation d'événements (survit au re-render du tiroir) ---------- */
  document.addEventListener('click', function(e){
    var t;
    if (t = e.target.closest('#navCart')){ e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-cart]')){ closeCart(); return; }

    // ajout depuis un bouton produit vedette (data-add = variant id)
    if (t = e.target.closest('[data-add]')){
      var vid = t.getAttribute('data-add');
      if (vid){ e.preventDefault(); addToCart({ id: vid, quantity: 1 }); return; }
    }
    // quantité tiroir
    if (t = e.target.closest('.drawer [data-cq]')){
      var key = t.getAttribute('data-key');
      var span = t.parentElement.querySelector('span');
      var cur = parseInt(span ? span.textContent : '1', 10) || 1;
      changeLine(key, Math.max(0, cur + parseInt(t.getAttribute('data-cq'), 10)));
      return;
    }
    if (t = e.target.closest('.drawer .rm')){ changeLine(t.getAttribute('data-key'), 0); return; }

    // vignettes galerie produit
    if (t = e.target.closest('.thumbs button')){
      document.querySelectorAll('.thumbs button').forEach(function(x){ x.setAttribute('aria-current','false'); });
      t.setAttribute('aria-current','true');
      var main = document.getElementById('pdpMain'); var full = t.getAttribute('data-full');
      if (main && full) main.src = full;
      return;
    }
    // sélecteur de teinte
    if (t = e.target.closest('.sw-btn')){
      var wrap = t.closest('.sw');
      wrap.querySelectorAll('.sw-btn').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      t.setAttribute('aria-pressed','true');
      var hidden = document.getElementById('teinteInput');
      if (hidden) hidden.value = t.getAttribute('data-teinte');
      return;
    }
    // stepper quantité produit
    if (t = e.target.closest('.qrow [data-q]')){
      var qv = document.getElementById('qv'), qi = document.getElementById('qtyInput');
      var val = Math.max(1, (parseInt(qv.textContent,10)||1) + parseInt(t.getAttribute('data-q'),10));
      qv.textContent = val; if (qi) qi.value = val;
      return;
    }
  });

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

  /* ---------- formulaire produit (ajout + achat immédiat) ---------- */
  var form = document.getElementById('pdpForm');
  if (form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      addToCart(new FormData(form), { msg: (parseInt((document.getElementById('qv')||{}).textContent,10)||1) > 1 ? 'Lampes ajoutées au panier' : 'Ajouté au panier' });
    });
    var buy = document.getElementById('pdpBuy');
    if (buy) buy.addEventListener('click', function(){ addToCart(new FormData(form), { checkout:true }); });
  }
})();
